import { apiSearch } from './utility';

const SEARCHING_RACK_FORMULAS = 'rackFormula/SEARCHING';
const RACK_FORMULA_SEARCH_FAILED = 'rackFormula/SEARCH_FAILED';

const initialState = {
	isSearching : false,
	searchFailed : false,
};

//- Reducers
export default (state = initialState, action) => {

	switch (action.type) {
		case SEARCHING_RACK_FORMULAS:
			return {
				...state,
				isSearching: true
			};
		case RACK_FORMULA_SEARCH_FAILED:
			return {
				...state,
				searchFailed : true,
			};
		default:
			return state;
	}
};

export const search = () => {
	return dispatch => {
		apiSearch({
			base : 'rackFormula',
			dispatch : dispatch,
			callback : function(err) {
				if (err) {
					dispatch({
						type: RACK_FORMULA_SEARCH_FAILED,
					});
				}
			}
		});
	};
};
